// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__ubUlg","checkbox":"TodoItem_checkbox__Yxhff","textInput":"TodoItem_textInput__jW-Y4"};